export const convertObjectToUrlParam = obj => {
	const urlSearchParam = new URLSearchParams()

	Object.entries(obj).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			value.forEach(item => urlSearchParam.append(`${key}[]`, item))
		} else {
			urlSearchParam.append(key, value)
		}
	})

	return decodeURIComponent(urlSearchParam.toString())
}
